import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Grid, Typography } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import { makeStyles } from 'transfix-ui/core/styles'
import { EditIcon } from 'transfix-icons'

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 600,
  },
}))

interface IControlPanelTabProps {
  onOpenStrategyManagerModal: () => void
}

export const ControlPanelTab: FC<IControlPanelTabProps> = ({
  onOpenStrategyManagerModal,
}: IControlPanelTabProps) => {
  const classes = useStyles()

  return (
    <>
      <Box mt={2} mb={2}>
        <Typography className={classes.bold} variant='body1' color='textPrimary' display='block'>
          Pricing Tools
        </Typography>
      </Box>
      <Box maxWidth={500}>
        <Card>
          <Grid container spacing={1} direction='row' alignItems='stretch'>
            <Grid item xs={11}>
              <Typography
                className={classes.bold}
                variant='body1'
                color='textPrimary'
                display='block'>
                Global Pricing Strategy
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton
                Icon={EditIcon}
                color='tertiary'
                data-test='edit-global-strategies'
                label='Edit'
                onClick={onOpenStrategyManagerModal}
                size='large'
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} direction='row' alignItems='stretch'>
            <Grid item xs={12}>
              <Typography variant='subtitle2' color='textSecondary'>
                View and edit pricing stratgies for all future RFPs.
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </>
  )
}
